export default [
    {
        // 图标解释标题
        title:$t('integration.gateway_type_icon'),
        // 图标类型
        type:"gatewayType", 
    },
    {
        title: $t('integration.gateway_status_icon_c'),
        type:'equiStatus'
    },
    {
        title:$t('integration.configuration_status_icon'),
        type:'configStatus'
    }
]